import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import logo from "@/assets/crystal-haccp-logo.png";

const NAV = [
  { to: "/platform", label: "Platform" },
  { to: "/platform#features", label: "Features" },
  { to: "/regional-compliance", label: "Regional Compliance" },
  { to: "/industries", label: "Industries" },
  { to: "/multi-location", label: "Multi-Location" },
  { to: "/pricing", label: "Pricing" },
  { to: "/resources", label: "Resources" },
];

export default function PublicHeader() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-40 glass-nav">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={logo}
            alt="Crystal HACCP Shield Logo"
            width={48}
            height={48}
            fetchPriority="high"
            decoding="async"
            className="h-12 w-12 object-contain"
          />
          <span className="text-white font-semibold text-lg tracking-wide">Crystal HACCP</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-5">
          {NAV.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="text-sm font-medium text-white/80 hover:text-white transition"
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/download-app"
            className="text-sm font-medium text-white/80 hover:text-white transition"
          >
            Download App
          </Link>
          {user ? (
            <Link
              to="/dashboard"
              className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold cta-primary"
            >
              Open Dashboard <ArrowRight size={16} />
            </Link>
          ) : (
            <>
              <Link to="/auth" className="text-sm font-semibold text-white/90 hover:text-white">
                Sign In
              </Link>
              <Link
                to="/auth?mode=signup"
                className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold cta-primary"
              >
                Get Started <ArrowRight size={16} />
              </Link>
            </>
          )}
        </nav>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/40 backdrop-blur-xl">
          <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col gap-4">
            {NAV.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                onClick={() => setOpen(false)}
                className="text-white/90 hover:text-white"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/download-app"
              className="text-white/90 hover:text-white"
            >
              Download App
            </Link>
            {user ? (
              <Link
                to="/dashboard"
                className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold cta-primary"
              >
                Open Dashboard <ArrowRight size={16} />
              </Link>
            ) : (
              <>
                <Link to="/auth" className="text-white/90">
                  Sign In
                </Link>
                <Link
                  to="/auth?mode=signup"
                  className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold cta-primary"
                >
                  Get Started <ArrowRight size={16} />
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
